import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import './CoachLayout.css';

const DASHBOARD_PULSES = [
  { label: "Today's sessions", value: '3 of 4 filled', status: 'Add waitlist', icon: '📅' },
  { label: 'Feedback streak', value: '12 glowing reviews', status: 'Keep it up!', icon: '💬' },
  { label: 'Prep queue', value: '2 slide decks', status: 'Due by 2:00 PM', icon: '🗂️' },
];

const QUICK_TOOLS = [
  { label: 'Share screen tips', icon: '🖥️' },
  { label: 'Drop surprises', icon: '🎁' },
  { label: 'Classroom mode', icon: '🚦' },
  { label: 'Mindful break', icon: '🧘' },
];

const CoachLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useUser();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      // Navigate anyway
      navigate('/');
    }
  };

  const tabs = [
    { path: '/coach/sessions', label: '📚 My Sessions' },
    { path: '/coach/courses', label: '📖 Courses & Sample Code' },
    { path: '/coach/content-studio', label: '🛠️ Content Studio' },
  ];

  return (
    <div className="coach-layout">
      <header className="coach-header">
        <div className="hero-copy">
          <p className="eyebrow">Coach HQ</p>
          <h1>Hi {user?.name || 'Coach'}, let’s fuel creativity today</h1>
          <p className="subline">Track your quests, drop surprises, and keep every learner energized.</p>
        </div>
        <button className="signout-btn" onClick={handleSignOut}>
          🚪 Sign Out
        </button>
      </header>
      <section className="coach-pulses">
        {DASHBOARD_PULSES.map((pulse) => (
          <article key={pulse.label} className="pulse-card">
            <span className="pulse-icon" aria-hidden="true">{pulse.icon}</span>
            <p className="pulse-label">{pulse.label}</p>
            <p className="pulse-value">{pulse.value}</p>
            <p className="pulse-status">{pulse.status}</p>
          </article>
        ))}
      </section>
      <nav className="coach-nav">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`nav-link ${location.pathname === tab.path ? 'active' : ''}`}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
      <section className="coach-tools">
        {QUICK_TOOLS.map((tool) => (
          <button key={tool.label} type="button" className="tool-chip">
            <span aria-hidden="true">{tool.icon}</span>
            {tool.label}
          </button>
        ))}
      </section>
      <div className="coach-content">
        {children}
      </div>
    </div>
  );
};

export default CoachLayout;

